// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBiBizDC7KSDw1RtxlzwLT1t_kbk6_fo6U",
  authDomain: "hoodup-fb1af.firebaseapp.com",
  databaseURL:
    "https://hoodup-fb1af-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "hoodup-fb1af",
  storageBucket: "hoodup-fb1af.appspot.com",
  messagingSenderId: "1017269810462",
  appId: "1:1017269810462:web:a11e7db637f7b26ef9450f",
  measurementId: "G-JWXZ23BT7T",
};

// Initialize Firebase

export const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const analytics = getAnalytics(app);
